export default {
  createVariable: 'Neue Variable erstellen',
};
